export const hackathonLinks = {
  faq: 'https://www.colosseum.org/hackathon#faqs',
  developerResources: 'https://www.colosseum.org/breakout/resources',
  exploreProjects: '/projects/explore',
  hallOfFame: '/hackathon/hall-of-fame',
  register: '/hackathon/register',
  findCofounders: '/profiles',
  lookingForTeam: '/forums/public/looking-for-team/',
  myProject: '/hackathon/project',
  createProject: '/hackathon/project/editor',
  editProject: '/hackathon/project/editor',
  submitProject: '/hackathon/project/submit',
  xTwitter: 'https://x.com/colosseum',
  colosseumLander: 'https://www.colosseum.org/',
  hackathonDashboard: '/hackathon',
  blog: 'https://blog.colosseum.org/',
};

export const getHackathonLink = (
  key: keyof typeof hackathonLinks,
  params?: Record<string, string>,
) => {
  let link = hackathonLinks[key];
  if (params) {
    const queryParams = new URLSearchParams(params);
    link += `?${queryParams.toString()}`;
  }
  return link;
};
